<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      职位管理
    </div>

    <el-form
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="输入搜索">
        <el-input v-model="keyword" placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchaxulisy">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="adc"></div>

    <div>共计：{{ arr }}人</div>
    <div class="adc"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="业务员姓名" prop="saleName"> </el-table-column>

      <el-table-column label="ID" prop="saleId"> </el-table-column>

      <el-table-column label="手机号码" prop="phone"> </el-table-column>

      <el-table-column label="创建时间" prop="addtime"> </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },

  data() {
    return {
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      arr: "",
      keyword: "",
      ruleForm: {
        name: "",
      },
      value1: "",
      form: {
        name: "",
        region: "",
      },

      addORUpdateVisible: false,
      tableData: [],
      searchForm: {
        name: "",
      },
    };
  },

  created() {
    this.getSaleCountByJobId();
    this.getJobDetail(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    getchaxu() {
      this.getJobDetail(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxulisy() {
      (this.keyword = ""),
        this.getJobDetail(this.searlist.curPage, this.searlist.pageSize);
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getJobDetail(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getJobDetail(v, this.searlist.pageSize);
    },

    getSaleCountByJobId() {
      this.$api.activitymsg
        .getSaleCountByJobId({
          jobId: this.$route.query.id,
        })
        .then((e) => {
          this.arr = e.data;
        });
    },

    getJobDetail(curr, pagesize) {
      this.$api.activitymsg
        .getJobDetail({
          current: curr,
          jobId: this.$route.query.id,
          size: pagesize,
          keyword: this.keyword,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },
  },
};
</script>

<style scoped>
.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.adc {
  height: 20px;
}
</style>
